import type { ValidatedApiClient } from '../types/api-client';
import { userGameSessionStatsResponseSchema } from './game-sessions-schema';

export const createGameSessionsApi = ({ validatedFetch }: ValidatedApiClient) => ({
    getUserStats: (titleId: number | string) =>
        validatedFetch(
            userGameSessionStatsResponseSchema,
            '/v3/analytics/game_sessions/user_stats',
            new URLSearchParams({ title_id: String(titleId) }),
        ),
});
